"use client";

import type { EventPageData } from "@/actions/event";
import type { PackForSaleRow } from "@/actions/packs";
import type { PackStripContext } from "@/features/packs/components/pack-strip";
import type { ViewerPackCoverage } from "@/features/packs/lib/eligibility";
import { EventDetailsTab } from "./event-details-tab";
import type { HiiveSummary, NormalizedOccurrence } from "./event-page.shared";

interface Props {
  event: EventPageData["event"];
  nextOccurrence: {
    startTime: Date;
    endTime: Date;
    timezone: string | null;
  } | null;
  scheduleOccurrence: NormalizedOccurrence | null;
  scheduleOccurrences: NormalizedOccurrence[];
  hiiveSlug: string;
  distanceKm: number | null;
  hiive: HiiveSummary;
  hiiveMemberCount: number;
  hiiveEventCount: number;
  packs?: PackForSaleRow[];
  packStripContext?: PackStripContext | null;
  viewerPackHolding?: ViewerPackCoverage | null;
}

export function EventDetailsTabClient({
  event,
  scheduleOccurrence,
  scheduleOccurrences,
  hiiveSlug,
  distanceKm,
  hiive,
  hiiveMemberCount,
  hiiveEventCount,
  packs,
  packStripContext,
  viewerPackHolding,
}: Props) {
  return (
    <EventDetailsTab
      event={event}
      scheduleOccurrence={scheduleOccurrence}
      scheduleOccurrences={scheduleOccurrences}
      distanceKm={distanceKm}
      hiive={hiive}
      hiiveMemberCount={hiiveMemberCount}
      hiiveEventCount={hiiveEventCount}
      packs={packs}
      packStripContext={packStripContext}
      viewerPackHolding={viewerPackHolding}
      hiiveSlug={hiiveSlug}
    />
  );
}
